
const StorageKey = {
  userToken: "user-token"
}

class StorageManager {
  getToken = () => localStorage.getItem(StorageKey.userToken)

  setToken(token) {
    localStorage.setItem(StorageKey.userToken, token)
  }

  removeToken() {
    localStorage.removeItem(StorageKey.userToken)
  }
}

export default new StorageManager()
